import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { Reservation } from '../models/reservation';
import { ResponseUtil } from '../../shared/utils/response-util';
import { EventStore } from './event.store';
import { OnyxEvent } from '../models/event';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class ReservationService {

  private eventUrl: string = this.environment.baseUrl + '/api/events';
  private selectedEvent: OnyxEvent;

  constructor(private http: AuthHttp,
              private eventStore: EventStore,
              private environment: EnvironmentConfiguration) {
    eventStore.selectedEvent.map( event => this.selectedEvent = event);
  }

  get(eventId: number): Observable<List<Reservation>> {
    const reservationUrl = `${this.eventUrl}/${eventId}/reservations/consumed`;

    return this.http.get(reservationUrl)
      .map((res: Response) => List<Reservation>(res.json()))
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/reservation-http-service.ts